module.exports = __webpack_public_path__ + "img/right-outfit-small.d453b6aa.jpg";